import DateFnsUtils from "@date-io/date-fns";
import {
  Grid,
  Link,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Checkbox,
  ListItemText,
  FormControlLabel,
  Pagination,
} from "@mui/material";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { Stack } from "@mui/system";
import * as React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useParams } from "react-router-dom";
import { AuthenticationContext, ImagesContext } from "../Context";
import { getHeaders } from "../utils/HeaderHelper";
import { formatToUsDate } from "../utils/DateHelper";
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from "@mui/icons-material";
import { CSVLink } from "react-csv";
import { format } from "date-fns";
import { toTitleCase } from "../utils/CaseFormatHelper";
import moment from "moment";
import { useFlash } from "../FlashContext";
import LoadingTable from "../shared/LoadingTable";
import MultiSelect from "../form/MultiSelect";
import { capitalize, formatZip } from "../utils/StringHelper";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: "fit-content",
    },
  },
};

interface Props {}

const NdmReportDetail: React.FC<Props> = (props: any) => {
  const authenticationSetting = React.useContext(AuthenticationContext);
  const { showToast } = useFlash();
  const [ndmReport, setNdmReport] = React.useState<any>(null);
  const [filteredNdmReport, setFilteredNdmReport] = React.useState<any>(null);
  const [startDateFilter, setStartDateFilter] = React.useState<any>(null);
  const [endDateFilter, setEndDateFilter] = React.useState<any>(null);
  const [customerFilter, setCustomerFilter] = React.useState<any>([]);
  const [customers, setCustomers] = React.useState<any>([]);
  const [drugFilter, setDrugFilter] = React.useState<any>([]);
  const [filterStarfieldPatients, setFilterStarfieldPatients] =
    React.useState(false);
  const [drugs, setDrugs] = React.useState<any>([]);
  const [diagnosisCodeFilter, setDiagnosisCodeFilter] = React.useState<any>([]);
  const [diagnosisCodes, setDiagnosisCodes] = React.useState<any>([]);
  const [checkedRows, setCheckedRows] = React.useState<any>([]);
  const [reportStatus, setReportStatus] = React.useState<string>(null);
  const [createPatientLoading, setCreatePatientLoading] =
    React.useState<boolean>(false);
  const [loadingTable, setLoadingTable] = React.useState<boolean>(false);
  const [searchClicked, setSearchClicked] = React.useState<boolean>(false);
  const [errors, setErrors] = React.useState<{ id: number; error: string }[]>(
    []
  );
  const [createdUsers, setCreatedUsers] = React.useState<any[]>([]);

  const [pageCount, setPageCount] = React.useState<number>(0);
  const [currentPage, setCurrentPage] = React.useState<number>(1);

  const imagesList = React.useContext(ImagesContext);
  const { id } = useParams();
  const initialLoad = React.useRef(true);
  React.useEffect(() => {
    if (initialLoad.current) {
      getThinNdmReport();
      getData();
      initialLoad.current = false;
    } else {
      getData(true);
    }
  }, [currentPage]);

  // React.useEffect(() => {
  //   console.log('drugFilter')
  //   console.log(drugFilter)
  // }, [drugFilter]);

  // React.useEffect(() => {
  //   console.log(createdUsers)
  // }, [createdUsers]);

  const searchData = async () => {
    setCurrentPage(1);
    setSearchClicked(true);
    await getData();
  };

  const getThinNdmReport = async () => {
    setLoadingTable(true);
    const queryParams = new URLSearchParams();
    queryParams.append("thin_ndm_report", true);
    const response = await fetch(`/ndm-reports/${id}?${queryParams}`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    });
    if (response.status === 404) {
      window.location.href = "/not-found";
      return;
    }

    try {
      var result = await response.json();
      setNdmReport(result.resource.ndm_report);
      setFilteredNdmReport(result.resource.ndm_report);
      setReportStatus(result.resource.ndm_report.status);
    } catch (error) {
      showToast({
        title: "Fetch Error",
        text: "Error fetching data",
        type: "error",
      });
      console.log(error);
    }
  };

  const getData = async (pageChange = false) => {
    setLoadingTable(true);

    const queryParams = new URLSearchParams();

    if (startDateFilter && endDateFilter) {
      if (startDateFilter) queryParams.append("start_date", startDateFilter);
      if (endDateFilter) queryParams.append("end_date", endDateFilter);
    }

    if (customerFilter.length > 0) {
      queryParams.append("customer_names", customerFilter.join(","));
    }

    if (drugFilter.length > 0) {
      queryParams.append("drugs", drugFilter.join(","));
    }

    if (diagnosisCodeFilter.length > 0) {
      queryParams.append("diagnosis_codes", diagnosisCodeFilter.join(","));
    }

    if (filterStarfieldPatients) {
      queryParams.append("no_starfield_patients", "true");
    }

    if (pageChange) {
      queryParams.append("page_change", "true");
    }

    queryParams.append("page", currentPage);

    const response = await fetch(`/ndm-reports/${id}?${queryParams}`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    });
    if (response.status === 404) {
      window.location.href = "/not-found";
      return;
    }

    try {
      var result = await response.json();
      setNdmReport(result.resource.ndm_report);
      setFilteredNdmReport(result.resource.ndm_report);
      setReportStatus(result.resource.ndm_report.status);
      setLoadingTable(false);
      if (result.resource.total_pages) {
        setPageCount(result.resource.total_pages);
      }
    } catch (error) {
      showToast({
        title: "Fetch Error",
        text: "Error fetching data",
        type: "error",
      });
      console.log(error);
      setLoadingTable(false);
    }
  };

  const handleCustomerFilterChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setCustomerFilter(typeof value === "string" ? value.split(",") : value);
  };

  // const populateFilters = (data) => {
  //   populateCustomers(data);
  //   populateDrugs(data);
  //   populateDiagnosisCodes(data);
  // };

  const createBulkPatient = async () => {
    setCreatePatientLoading(true);
    var newErrors = [];

    const element: HTMLElement = document.getElementById("create-bulk");
    element.style.color = "#ff890a";

    const checkedData = filteredNdmReport?.data?.reduce((acc, row, index) => {
      if (checkedRows.includes(row.id)) {
        acc.push({
          ...row,
          // originalIndex: index,
        });
      }
      return acc;
    }, []);

    fetch("/ndm-reports/bulk_patient", {
      method: "POST",
      headers: getHeaders(authenticationSetting.csrfToken),
      body: JSON.stringify({
        data: checkedRows,
      }),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.success == false) {
          if (newErrors.length > 0) {
            setErrors([]);
          } else {
            alert(result.error);
          }
          if (result["new_patients"]) {
            setCreatedUsers((prev) => [...prev, ...result["new_patients"]]);
          }
        } else {
          if (result["new_patients"]) {
            setCreatedUsers((prev) => [...prev, ...result["new_patients"]]);
          }
          if (result["failed_records"]) {
            result["failed_records"].forEach((error) => newErrors.push(error));
            showToast({
              text: "Some records failed to create a Patient",
              type: "warning",
            });
          } else if (result["existing_patients"]) {
            result["existing_patients"].forEach((error) =>
              newErrors.push(error)
            );
            showToast({
              text: "Some records are duplicates",
              type: "warning",
            });
          } else {
            showToast({
              text: "Patients created successfully.",
              type: "success",
            });
          }
          setErrors(newErrors);
        }
        setCheckedRows([]);
        element.style.color = null;
      })
      .finally(() => {
        setCreatePatientLoading(false);
      });
  };

  console.log("filteredNdmReport data", filteredNdmReport?.data)

  const getCsvData = () => {
    const checkedData = filteredNdmReport?.data?.filter((row, index) =>
      checkedRows.includes(row.id)
    );

    const formattedData = checkedData?.map(
      ({
        first_name,
        last_name,
        middle_name,
        dob,
        gender,
        address_line_1,
        address_line_2,
        city,
        state,
        zip,
      }) => ({
        "first_name*": first_name,
        middle_name,
        "last_name*": last_name,
        "birth_date*": format(new Date(dob), "yyyyMMdd"),
        email_adress: "",
        gender,
        "Mobile Phone Number": "",
        address: address_line_1,
        address_line_2: address_line_2,
        city,
        state,
        zip,
        "Insurance Type": "",
        "Insurance Plan or Program Name": "",
        "Insured's ID #": "",
        "Insured's First Name": "",
        "Insured's Last Name": "",
        "Insured's Date of Birth": "",
        "Insured's Address": "",
        "Insured's City": "",
        "Insured's State": "",
        "Insured's Zip": "",
        "Insured's Phone Number": "",
        "Patient Relationship to Insured": "",
      })
    );

    return formattedData ?? [];
  };

  const populateCustomers = (data) => {
    const uniqueCustomerNames = Array.from(
      new Set(
        data?.flatMap((claim) => {
          const medicalClaimNames = Array.isArray(claim.medical_claims)
            ? claim.medical_claims.map((claim) => claim.ndm_provider?.dba)
            : [];

          const drugClaimNames = Array.isArray(claim.drug_claims)
            ? claim.drug_claims.map((claim) => claim.ndm_provider?.dba)
            : [];

          return [...medicalClaimNames, ...drugClaimNames].filter(Boolean);
        })
      )
    );

    setCustomers(uniqueCustomerNames);
  };

  const populateDrugs = (data) => {
    const uniqueDrugNames = Array.from(
      new Set(
        data?.flatMap((claim) => {
          const drugClaimNames = Array.isArray(claim.drug_claims)
            ? claim.drug_claims.map((claim) => claim.drug_name)
            : [];

          return [...drugClaimNames];
        })
      )
    );

    setDrugs(uniqueDrugNames);
  };

  const populateDiagnosisCodes = (data) => {
    const uniqueDiagnosisCodes = new Set(
      data?.flatMap((person) =>
        (person.medical_claims || []).flatMap(
          (claim) => claim.diagnosis_codes || []
        )
      )
    );

    setDiagnosisCodes(Array.from(uniqueDiagnosisCodes));
  };

  const resetFilters = () => {
    setStartDateFilter(null);
    setEndDateFilter(null);
    setCustomerFilter([]);
    setDrugFilter([]);
    setDiagnosisCodeFilter([]);
    setFilterStarfieldPatients(false);
  };

  const renderTable = () => {
    if (loadingTable) {
      return (
        <TableRow>
          <TableCell
            colSpan={100}
            align="center"
            width="100%"
            style={{ borderBottom: "none" }}
          >
            <LoadingTable />
          </TableCell>
        </TableRow>
      );
    }

    // if (!startDateFilter || !endDateFilter) {
    //   return (
    //     <TableRow>
    //       <TableCell colSpan={100} align="center" width="100%">
    //         Please set date filters to see data.
    //       </TableCell>
    //     </TableRow>
    //   );
    // }

    if (filteredNdmReport?.data?.length > 0) {
      return filteredNdmReport.data.map((row, index) => {
        if (createdUsers.includes(row.id)) {
          return <> </>;
        }

        return (
          <CollapsibleTableRow
            row={row}
            id={row.id}
            checkedRows={checkedRows}
            errorMessage={errors.find((e) => e.id === row.id)?.error || ""}
            handleRowSelect={(i) => {
              setCheckedRows(
                checkedRows.includes(i)
                  ? checkedRows.filter((id) => id !== i)
                  : [...checkedRows, i]
              );
            }}
            key={index}
          />
        );
      });
    }

    if (searchClicked && filteredNdmReport?.data?.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={100} align="center" width="100%">
            No data found.
          </TableCell>
        </TableRow>
      );
    }

    return (
      <TableRow>
        <TableCell colSpan={100} align="center" width="100%">
          Click search.
        </TableCell>
      </TableRow>
    );
  };

  const drugFetchOptions = async (query: string): Promise<Option[]> => {
    try {
      const response = await fetch(
        `/ndm-reports/${id}/drug_name_search?drug_name=${encodeURIComponent(
          query
        )}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        console.error(response.body);
        showToast({
          title: "Error Fetching Drug Names",
          text: "Failed to fetch drug names.",
          type: "error",
        });
        return [];
      }

      const data = await response.json();
      return data.resource.drug_names.map((drug_name: string) => ({
        title: drug_name,
        value: drug_name,
      }));
    } catch (error) {
      showToast({
        title: "Error Fetching Drug Names",
        text: "An error occurred while fetching drug names.",
        type: "error",
      });
      console.error("Error fetching drug names:", error);
      return [];
    }
  };

  const diagnosisFetchOptions = async (query: string): Promise<Option[]> => {
    const results = await fetch(
      `https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms=${encodeURIComponent(
        query
      )}`,
      {
        method: "GET",
        headers: getHeaders(authenticationSetting.csrfToken),
      }
    )
      .then((result) => result.json())
      .then((result) => {
        return result[3].map((codeInfo: string[]) => ({
          title: codeInfo[0] + " - " + codeInfo[1],
          value: codeInfo[0],
        }));
      })
      .catch((error) => {
        console.log(error);
        showToast({
          title: "Error Fetching Diagnosis Codes",
          text: "Failed to fetch diagnosis codes.",
          type: "error",
        });
        return [];
      });
    return results;
  };

  const customerFetchOptions = async (query: string): Promise<Option[]> => {
    try {
      const response = await fetch(
        `/ndm-reports/${id}/dba_search?dba=${encodeURIComponent(query)}`,
        {
          method: "GET",
        }
      );

      const data = await response.json();
      return data.resource.dba_names.map((dba_name: string) => ({
        title: dba_name,
        value: dba_name,
      }));
    } catch (error) {
      showToast({
        title: "Error Fetching DBA Names",
        text: "An error occurred while fetching dba names.",
        type: "error",
      });
      console.error("Error fetching dba names:", error);
      return [];
    }
  };

  return (
    <div className="main-content-outer">
      {(!ndmReport || !ndmReport.status) && <div>Loading....</div>}
      {ndmReport?.status === "completed" && (
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          style={{
            paddingLeft: "120px",
            paddingRight: "18px",
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              maxHeight: "calc(100vh - 117px)",
              height: "calc(100vh - 117px)",
              paddingBottom: "0px",
            }}
            className="patient-edit-container patient-edit-form provider-action-report"
          >
            <Grid container>
              {/* <Grid
                className="patient-edit-header"
                container
                justifyContent="space-between"
              >
                <Grid item xs={4}>
                  <p className="secondary-label">NDM Report</p>
                </Grid>
              </Grid> */}
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Grid item xs={12}>
                  <h3 style={{ paddingLeft: 22 }}>Payer Patient Data Import</h3>
                  <div
                    className="divider-orange"
                    style={{ margin: "0px", width: "100%" }}
                  ></div>
                </Grid>
              </Grid>
              <Grid
                container
                className="form-container"
                style={{ paddingTop: "15px", paddingRight: "40px" }}
              >
                <Grid item xs={2} className="left-column">
                  <Card className="box-outlined" variant="outlined">
                    <Link className="report-nav-link" href={`/ndm-report`}>
                      <ArrowBackIosIcon
                        className="report-back-arrow"
                        style={{ verticalAlign: "bottom" }}
                      />
                      Back
                    </Link>
                  </Card>
                  {/* <h3> Date Range </h3> */}
                  {/* <p>Encounter Date</p>
                  <Grid item xs={12} className="field-container">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        autoOk={true}
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        value={startDateFilter}
                        onChange={(value) => {
                          setStartDateFilter(value);
                        }}
                        className="report-date-input"
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>

                  <Grid item xs={12} className="field-container">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        autoOk={true}
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        value={endDateFilter}
                        onChange={(value) => {
                          setEndDateFilter(value);
                        }}
                        className="report-date-input"
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid> */}
                  <p>Search</p>

                  <Grid item xs={12}>
                    <p style={{ fontSize: "0.9rem" }}> Search Drug(s) </p>
                    <MultiSelect
                      placeholder="Search drug names"
                      fetchOptions={drugFetchOptions}
                      onChange={(items) => {
                        setDrugFilter(items.map((i) => i.value));
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={12}>
                    <FormControl variant="standard" style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-helper-label"
                        htmlFor="drug"
                      >
                        Search Drug(s)
                      </InputLabel>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} className="field-container">
                    
                    <FormControl variant="standard" style={{ width: "100%" }}>
                      <Select
                        labelId="drug_filter"
                        id="drug_filter"
                        multiple
                        style={{ width: "100%", marginLeft: 0, paddingTop: 20 }}
                        value={drugFilter}
                        onChange={handleDrugFilterChange}
                        renderValue={(selected: Array<string>) =>
                          selected.join(", ")
                        }
                        MenuProps={MenuProps}
                      >
                        {drugs.map((d, index) => (
                          <MenuItem
                            key={index}
                            value={d}
                            style={{ padding: 10 }}
                          >
                            <Checkbox
                              checked={drugFilter && drugFilter.indexOf(d) > -1}
                            />
                            <ListItemText primary={toTitleCase(d)} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid> */}

                  <Grid item xs={12}>
                    <p style={{ fontSize: "0.9rem" }}>
                      {" "}
                      Search Diagnosis Code(s){" "}
                    </p>
                    <MultiSelect
                      placeholder="Search diagnosis codes"
                      fetchOptions={diagnosisFetchOptions}
                      onChange={(items) => {
                        setDiagnosisCodeFilter(items.map((i) => i.value));
                      }}
                      charThreshold={2}
                    />
                  </Grid>

                  {/* <Grid item xs={12}>
                    <FormControl variant="standard" style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-helper-label"
                        htmlFor="drug"
                      >
                        Search Diagnosis Code(s)
                      </InputLabel>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} className="field-container">
                    <FormControl variant="standard" style={{ width: "100%" }}>
                      <Select
                        labelId="diagnosis_code_filter"
                        id="diagnosis_code_filter"
                        multiple
                        style={{ width: "100%", marginLeft: 0, paddingTop: 20 }}
                        value={diagnosisCodeFilter}
                        onChange={handleDiagnosisCodeChange}
                        renderValue={(selected: Array<string>) =>
                          selected.join(", ")
                        }
                        MenuProps={MenuProps}
                      >
                        {diagnosisCodes.map((d, index) => (
                          <MenuItem
                            key={index}
                            value={d}
                            style={{ padding: 1 }}
                          >
                            <Checkbox
                              checked={
                                diagnosisCodeFilter &&
                                diagnosisCodeFilter.indexOf(d) > -1
                              }
                            />
                            <ListItemText primary={d} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid> */}

                  <Grid item xs={12} className="field-container">
                    <Button
                      className="basic-button"
                      onClick={searchData}
                      style={{ height: "40px" }}
                    >
                      Search
                    </Button>
                  </Grid>
                  <div className="divider-orange"></div>

                  <h3> Filter </h3>

                  <Grid item xs={12}>
                    <p style={{ fontSize: "0.9rem" }}> Customer </p>
                    <MultiSelect
                      placeholder="Search customers"
                      fetchOptions={customerFetchOptions}
                      onChange={(items) => {
                        setCustomerFilter(items.map((i) => i.value));
                      }}
                      charThreshold={3}
                    />
                  </Grid>

                  {/* <Grid item xs={12} className="field-container">
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-helper-label"
                        htmlFor="customer"
                      >
                        Customer
                      </InputLabel>
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    className="field-container"
                    style={{ marginTop: "20px" }}
                  >
                    <FormControl variant="standard" style={{ width: "100%" }}>
                      <Select
                        labelId="customer_filter"
                        id="customer_filter"
                        multiple
                        style={{ width: "100%", marginLeft: 0 }}
                        value={customerFilter}
                        onChange={handleCustomerFilterChange}
                        renderValue={(selected: Array<string>) =>
                          selected.join(", ")
                        }
                        MenuProps={MenuProps}
                      >
                        {customers.map((c) => (
                          <MenuItem key={c} value={c} style={{ padding: 10 }}>
                            <Checkbox
                              checked={
                                customerFilter && customerFilter.indexOf(c) > -1
                              }
                            />
                            <ListItemText primary={c} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid> */}

                  <Grid item style={{ textAlign: "right" }}>
                    <p
                      onClick={resetFilters}
                      style={{
                        color: "red",
                        marginTop: "15px",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    >
                      Clear Filters
                    </p>
                  </Grid>
                </Grid>
                <Grid item xs={10} className="right-column">
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      className="shadowed-box"
                    >
                      <Grid container>
                        <Grid
                          className="patient-edit-header"
                          container
                          justifyContent="space-between"
                        >
                          <Grid item xs={4}>
                            <p className="secondary-label"> Report Details </p>
                          </Grid>
                          <Grid item xs={2}>
                            <Stack direction="row">
                              <Stack
                                direction="column"
                                onClick={() => {
                                  createBulkPatient();
                                }}
                                style={{
                                  cursor: "pointer",
                                  marginRight: "20px",
                                  pointerEvents:
                                    getCsvData().length === 0 ? "none" : "auto",
                                }}
                                id="create-bulk"
                              >
                                <span
                                  className="text-center"
                                  style={{ marginTop: "10px" }}
                                >
                                  {createPatientLoading ? (
                                    <img
                                      src={imagesList.spinner_src}
                                      style={{ width: "24px" }}
                                    ></img>
                                  ) : (
                                    <PersonAddIcon
                                      style={{
                                        color:
                                          getCsvData().length === 0 &&
                                          "#A29D9B",
                                      }}
                                    />
                                  )}
                                </span>
                                <p
                                  style={{
                                    textDecoration: "none",
                                    textAlign: "center",
                                    fontSize: "14px",
                                    margin: "0px",
                                    color:
                                      getCsvData().length === 0 && "#A29D9B",
                                  }}
                                >
                                  Create Patients
                                </p>
                              </Stack>
                              <Link
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  pointerEvents:
                                    getCsvData().length === 0 ? "none" : "auto",
                                }}
                              >
                                <span style={{ marginTop: "10px" }}>
                                  <ImportExportIcon
                                    style={{
                                      color:
                                        getCsvData().length === 0 && "#A29D9B",
                                    }}
                                  />
                                </span>
                                <CSVLink
                                  data={getCsvData()}
                                  filename={"patient-details.csv"}
                                  style={{
                                    textDecoration: "none",
                                    textAlign: "center",
                                    color:
                                      getCsvData().length === 0 && "#A29D9B",
                                  }}
                                >
                                  Export CSV
                                </CSVLink>
                              </Link>
                            </Stack>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <TableContainer
                            component={Paper}
                            className="ndm-reports-table"
                            style={{
                              overflow: "scroll",
                              height: "calc(100vh - 360px)"
                            }}
                          >
                            <Table
                              className="table"
                              aria-label="collapsible table"
                              stickyHeader
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  />
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  />
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Import?
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Patient
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    DOB
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className="table-header"
                                  >
                                    Customer
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Drug
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Drug Name
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    NDC
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Fill Date
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Quantity Dispensed
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Diagnosis Code(s)
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Medicaid ID
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Patient MMIS ID
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Medicaid End Date
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Servicing Provider NPI
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Prescriber NPI
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Address Line One
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    Address Line Two
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className="table-header"
                                  >
                                    ZIP Code
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>{renderTable()}</TableBody>
                            </Table>
                          </TableContainer>
                          {pageCount > 0 && (
                            <Pagination
                              count={pageCount}
                              page={currentPage}
                              onChange={(
                                _event: React.ChangeEvent,
                                page: number
                              ) => setCurrentPage(page)}
                              sx={{
                                margin: "0 auto",
                                paddingTop: "16px",
                                marginBottom: "10px",
                                "& .MuiPagination-ul": {
                                  justifyContent: "center",
                                },
                              }}
                              boundaryCount={3}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {ndmReport?.status === "invalid" && (
        <div className="resource-catalog">
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            className="container"
            sx={{ marginTop: "100px!important" }}
          >
            <Grid item xs={12}>
              <div className="userAdminInformation">
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="stretch"
                  className="adminHeader"
                >
                  <Grid item xs={12} md={6}>
                    <h3>Payer Patient Data Import</h3>
                  </Grid>
                </Grid>
                <div className="divider"></div>
                <div
                  className="userAdminInformation"
                  style={{ margin: "20px" }}
                >
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="stretch"
                    className="adminHeader"
                  >
                    <Grid item xs={12} md={6}>
                      <h3>Failed Data Report</h3>
                    </Grid>
                  </Grid>
                  <div className="divider"></div>
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="stretch"
                  >
                    <Grid item xs={12}>
                      <div className="careHeader">
                        <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                        >
                          <Grid item xs={12} md={12}>
                            <p
                              style={{
                                textAlign: "left",
                                font: "16px QuicksandMedium",
                                marginBottom: 30,
                              }}
                            >
                              {formatToUsDate(new Date())} <br />
                              {moment(ndmReport.created_at).format(
                                "MM/DD/YY HH:mm A"
                              )}{" "}
                              upload started <br />
                              {moment(ndmReport.updated_at).format(
                                "MM/DD/YY HH:mm A"
                              )}{" "}
                              upload ended
                            </p>
                            <p
                              style={{
                                textAlign: "left",
                                font: "16px QuicksandMedium",
                                marginBottom: 30,
                              }}
                            >
                              Failed Data:
                            </p>
                            <TableContainer
                              component={Paper}
                              style={{ marginRight: 20 }}
                            >
                              <Table aria-label="simple table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="left">
                                      <strong
                                        style={{
                                          fontFamily: "QuicksandMedium",
                                        }}
                                      >
                                        Name
                                      </strong>
                                    </TableCell>
                                    <TableCell align="left">
                                      <strong
                                        style={{
                                          fontFamily: "QuicksandMedium",
                                        }}
                                      >
                                        Reason Failed
                                      </strong>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {ndmReport.issues?.map((error, index) => (
                                    <TableRow
                                      key={index}
                                      className={
                                        index % 2 == 0 ? "rowEven" : "row"
                                      }
                                    >
                                      <TableCell
                                        component="th"
                                        scope="row"
                                        style={{
                                          fontFamily: "QuicksandMedium",
                                          fontSize: 12,
                                          paddingLeft: 10,
                                          paddingRight: 10,
                                        }}
                                      >
                                        {error.param}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          fontFamily: "QuicksandMedium",
                                          fontSize: 12,
                                          paddingLeft: 10,
                                          paddingRight: 10,
                                        }}
                                      >
                                        {error.reason}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      )}
      {ndmReport?.status !== "invalid" && ndmReport?.status !== "completed" && (
        <div className="resource-catalog">
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            className="container"
          >
            <Grid item xs={12}>
              {capitalize(ndmReport?.status)}...
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  );
};

const CollapsibleTableRow = ({
  row,
  id,
  checkedRows,
  handleRowSelect,
  errorMessage,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const claims = (row.drug_claims || []).concat(row.medical_claims || []);

  const handleToggle = () => {
    setOpen(!open);
  };

  const onCheckboxChange = (event) => {
    event.stopPropagation();
    handleRowSelect(id);
  };

  return (
    <>
      <TableRow
        onClick={() => {
          claims.length > 1 && handleToggle();
        }}
        style={{
          background:
            errorMessage.length > 0
              ? "#FFFF00"
              : checkedRows.includes(id)
              ? "#efe9e7"
              : "none",
        }}
        id={`table-row-${id}`}
      >
        <TableCell
          className="table-row"
          style={
            claims.length > 0 && errorMessage.length > 0
              ? { position: "relative", height: "3.5rem" }
              : { position: "relative", height: "3.5rem" }
          }
        >
          {claims.length > 0 ? (
            <div>
              {claims.length > 1 && (
                <IconButton aria-label="expand row" size="small">
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              )}
              <p style={{ marginTop: "-5px" }}>
                <small>
                  {claims.length} of {claims.length}
                </small>
              </p>
              <div
                className="error-container"
                style={
                  errorMessage.length > 0
                    ? {
                        position: "absolute",
                        color: "#ff0000",
                        bottom: ".5rem",
                      }
                    : {}
                }
              >
                {errorMessage.length > 0 ? `Failed: ${errorMessage}` : ""}
              </div>
            </div>
          ) : (
            <div
              className="error-container"
              style={
                errorMessage.length > 0
                  ? { position: "absolute", color: "#ff0000", bottom: ".5rem" }
                  : {}
              }
            >
              {errorMessage.length > 0 ? `Failed: ${errorMessage}` : ""}
            </div>
          )}
        </TableCell>
        <TableCell className="table-row">
          {row.starfield_user_id ? props.small_logo_src : null}
        </TableCell>
        <TableCell className="table-row">
          <Checkbox
            checked={checkedRows.includes(id)}
            onChange={onCheckboxChange}
            onClick={(event) => event.stopPropagation()}
          />
        </TableCell>
        <TableCell className="table-row">{`${row.last_name}, ${row.first_name}`}</TableCell>
        <TableCell className="table-row">{formatToUsDate(row.dob)}</TableCell>
        {claims && claims.length > 0 ? (
          <>
            <TableCell className="table-row">
              {!open && claims && claims.length > 0 && (
                <div>
                  <p>{claims[0].ndm_provider?.dba}</p>
                </div>
              )}
              <Collapse in={open} timeout="auto" unmountOnExit>
                {claims &&
                  claims.map((claim, index) => (
                    <div key={index}>
                      <p>{claim.ndm_provider?.dba}</p>
                    </div>
                  ))}
              </Collapse>
            </TableCell>
            <TableCell className="table-row">
              {!open && claims && claims.length > 0 && (
                <div>
                  <p>{claims[0].drug}</p>
                </div>
              )}
              <Collapse in={open} timeout="auto" unmountOnExit>
                {claims &&
                  claims.map((claim, index) => (
                    <div key={index}>
                      <p>{claim.drug}</p>
                    </div>
                  ))}
              </Collapse>
            </TableCell>
            <TableCell className="table-row">
              {!open && claims && claims.length > 0 && (
                <div>
                  <p>{toTitleCase(claims[0].drug_name)}</p>
                </div>
              )}
              <Collapse in={open} timeout="auto" unmountOnExit>
                {claims &&
                  claims.map((claim, index) => (
                    <div key={index}>
                      <p>{toTitleCase(claim.drug_name)}</p>
                    </div>
                  ))}
              </Collapse>
            </TableCell>
            <TableCell className="table-row">
              {!open && claims && claims.length > 0 && (
                <div>
                  <p>{claims[0].ndc_code}</p>
                </div>
              )}
              <Collapse in={open} timeout="auto" unmountOnExit>
                {claims &&
                  claims.map((claim, index) => (
                    <div key={index}>
                      <p>{claim.ndc_code}</p>
                    </div>
                  ))}
              </Collapse>
            </TableCell>

            <TableCell className="table-row">
              {!open && claims && claims.length > 0 && (
                <div>
                  <p>
                    {claims[0].service_month
                      ? formatToUsDate(claims[0].service_month)
                      : null}
                  </p>
                </div>
              )}
              <Collapse
                in={open}
                timeout="auto"
                unmountOnExit
                collapsedSize={100}
              >
                {claims &&
                  claims.map((claim, index) => (
                    <div key={index}>
                      <p>
                        {claim.service_month
                          ? formatToUsDate(claim.service_month)
                          : null}
                      </p>
                    </div>
                  ))}
              </Collapse>
            </TableCell>

            <TableCell className="table-row">
              {!open && claims && claims.length > 0 && (
                <div>
                  <p>{claims[0].quantity_dispensed}</p>
                </div>
              )}
              <Collapse in={open} timeout="auto" unmountOnExit>
                {claims &&
                  claims.map((claim, index) => (
                    <div key={index}>
                      <p>{claim.quantity_dispensed}</p>
                    </div>
                  ))}
              </Collapse>
            </TableCell>

            <TableCell className="table-row">
              {!open && claims && claims.length > 0 && (
                <div>
                  <p>
                    {
                      (claims.find(claim => claim.diagnosis_codes && claim.diagnosis_codes.length > 0)?.diagnosis_codes || []).join(", ")
                    }
                  </p>
                </div>
              )}
              <Collapse in={open} timeout="auto" unmountOnExit>
                {claims &&
                  claims.map((claim, index) => (
                    <div key={index}>
                      <p>{claim.diagnosis_codes?.join(", ")}</p>
                    </div>
                  ))}
              </Collapse>
            </TableCell>
            <TableCell className="table-row">{row.medicaid_id}</TableCell>
            <TableCell className="table-row">{row.mmis_id}</TableCell>
            <TableCell className="table-row">{row.medicaid_end_date}</TableCell>
            <TableCell>
              {!open && claims && claims.length > 0 && (
                <div>
                  <p>{claims[0].servicing_provider_npi}</p>
                </div>
              )}
              <Collapse in={open} timeout="auto" unmountOnExit>
                {claims &&
                  claims.map((claim, index) => (
                    <div key={index}>
                      <p>{claim.servicing_provider_npi}</p>
                    </div>
                  ))}
              </Collapse>
            </TableCell>
            <TableCell>
              {!open && claims && claims.length > 0 && (
                <div>
                  <p>{claims[0].prescribing_provider_npi}</p>
                </div>
              )}
              <Collapse in={open} timeout="auto" unmountOnExit>
                {claims &&
                  claims.map((claim, index) => (
                    <div key={index}>
                      <p>{claim.prescribing_provider_npi}</p>
                    </div>
                  ))}
              </Collapse>
            </TableCell>
            <TableCell className="table-row">{row.address_line_1}</TableCell>
            <TableCell className="table-row">{row.address_line_2}</TableCell>
            <TableCell className="table-row">{formatZip(row.zip)}</TableCell>
          </>
        ) : (
          <>
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
          </>
        )}
      </TableRow>
    </>
  );
};

export default NdmReportDetail;
